import { Component, input, OnDestroy, OnInit, output } from "@angular/core";
import { WhiteLabelInfo } from "src/app/core/models/model";
import { PaymentDetails } from "../shared/models/paymentdetails";
import { takeUntil } from "rxjs/operators";
import { PaymentService } from "../shared/services/payment.service";
import { Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { ToastrService } from "ngx-toastr";

interface OpayInitPayload {
  productName: string;
  reference: string;
  amount: string;
  country: string;
  returnUrl: string;
  callbackUrl: string;
  cancelUrl: string;
  narration: string;
  customerId: string;
  // accountNumber: string;
  bankName: "OPAY";
}

@Component({
  selector: "app-opay",
  templateUrl: "./opay.component.html",
  styleUrl: "./opay.component.css",
  standalone: false,
})
export class OpayComponent implements OnInit, OnDestroy {
  checkOutEnvURL = environment.checkOutURL;
  paymentReference = input.required<string>();
  paymentDetails = input.required<PaymentDetails>();
  whiteLabelInfo = input<WhiteLabelInfo | null>(null);

  destroy$: Subject<boolean> = new Subject();

  submitPayment = output();

  public countdown: number;
  private readonly initialCountdown = 5;

  expirationTime: number | null = null;
  timerInterval: any;

  constructor(
    private payservice: PaymentService,
    private toastr: ToastrService,
  ) {
    this.countdown = this.initialCountdown;
  }

  makePayment() {
    const amountPlusFees =
      this.paymentDetails().amount + (Number(this.paymentDetails().fees) ?? 0);
    const encryptedReturnUrlParams = btoa(
      `${this.paymentDetails().referenceId}/${this.paymentDetails().amount}/pending`,
    );
    const encryptedCancelUrlParams = btoa(
      `${this.paymentDetails().referenceId}/${this.paymentDetails().amount}/failed`,
    );
    const url = new URL(this.paymentDetails().paymentUrl);
    const urlPath = url.pathname;
    let request: OpayInitPayload = {
      productName: this.paymentDetails().clientId, // is clientID for now
      reference: this.paymentDetails().referenceId,
      amount: String(amountPlusFees),
      country: "NG", //this.paymentDetails().country, // NG not NGA
      // returnUrl: `${this.checkOutEnvURL}/checkout/success/${this.paymentDetails().amount}/success/${btoa("Payment already completed")}`,
      // callbackUrl: `${this.checkOutEnvURL}/checkout/success/${amountPlusFees}/success/${btoa("Payment already completed")}`,
      // cancelUrl: `${this.checkOutEnvURL}/failure/${amountPlusFees}/${this.paymentDetails().referenceId}/${btoa("Payment already completed")}`,
      returnUrl: `${this.checkOutEnvURL}/banks/${encryptedReturnUrlParams}`,
      callbackUrl: `${this.checkOutEnvURL}/banks/${encryptedReturnUrlParams}`,
      cancelUrl: `${this.checkOutEnvURL}${urlPath}`,
      narration:
        this.paymentDetails()["metadata"].email ??
        this.paymentDetails()["userId"],
      customerId:
        this.paymentDetails()["metadata"].email ??
        this.paymentDetails()["userId"],
      bankName: "OPAY",
    };

    this.payservice
      .initiateBankTransaction(request)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res.responseCode === "00") {
            document.location.href = res.cashierUrl;
          }
        },
        error: (err) => {
          this.toastr.error(
            err?.error?.responseMessage ??
              "Unable to complete your request at the moment, please try again",
          );
        },
      });
  }

  ngOnInit(): void {
    this.startCountdown();
    setTimeout(() => {
      // this.makePayment();
    }, 5000);
  }

  startCountdown(seconds: number = 5): void {
    this.clearCountdown();

    const expirationTime = Date.now() + seconds * 1000;

    this.timerInterval = window.setInterval(() => {
      const remaining = Math.max(
        Math.ceil((expirationTime - Date.now()) / 1000),
        0,
      );

      this.countdown = remaining;

      if (remaining === 0) {
        this.clearCountdown();
        this.makePayment();
      }
    }, 1000);
  }

  clearCountdown(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.clearCountdown();
  }
}
